import { defaultUnitSystem, type UnitSystem } from '@/core/telemetry/overlay';
import type { EditRecipe } from '@/core/project/recipe';
import { readPreference, writePreference } from './preferences';

/** km/h or mph: the person's last choice, else a guess from the browser's region. */
export function preferredUnits(): UnitSystem {
  const stored = readPreference('units');
  return stored === 'metric' || stored === 'imperial' ? stored : defaultUnitSystem(globalThis.navigator?.language);
}

export const rememberUnits = (units: UnitSystem): void => writePreference('units', units);

export const withPreferredUnits = (recipe: EditRecipe): EditRecipe => ({ ...recipe, telemetry: { ...recipe.telemetry, units: preferredUnits() } });
